import React from "react"

import { color } from "../../../../atoms/colors"
import { Star } from "../../../../utils/IconsList"
import { StarWrap, Cell } from "../../styles/TableCell.styled"

const PackageTableStars = ({ starAmount }) => {
  return (
    <Cell>
      <StarWrap color={`${color.logoBlue[400]}`}>
        {Array(starAmount).fill(<Star />)}
      </StarWrap>
    </Cell>
  )
}

export default PackageTableStars
